module.exports = __webpack_public_path__ + "561a14df04b3c8d57a8f11af1ed3c27c.jpg";